import { DataResponseOrganization, Organization, OrganizationCreateRequest, OrganizationSearchRequest, OrganizationUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class OrganizationService {

    async createOrganization(request: OrganizationCreateRequest): Promise<Organization> {
        return falconClients.organizations.createOrganization({
            organizationCreateRequest: request,
        });
    }

    async searchOrganizations(request: OrganizationSearchRequest): Promise<DataResponseOrganization> {
        return falconClients.organizations.searchOrganizations({
            organizationSearchRequest: request,
        });
    }

    async getOrganizationById(id: string): Promise<Organization> {
        return falconClients.organizations.getOrganizationById({
            id,
        });
    }

    async updateOrganizationById(id: string, data: OrganizationUpdateRequest): Promise<Organization> {
        return falconClients.organizations.updateOrganizationById({
            id,
            organizationUpdateRequest: data,
        });
    }

    async createOrgInviteCode(orgId: string, code: string): Promise<void> {
        return falconClients.organizations.createOrgInviteCode({
            id: orgId,
            orgInviteCodeCreateRequest: { code },
        });
    }

    async deleteOrgInviteCode(orgId: string): Promise<void> {
        return falconClients.organizations.deleteOrgInviteCode({
            id: orgId,
        });
    }
}